import { render, staticRenderFns } from "./Fees.vue?vue&type=template&id=1f87e3dc&scoped=true&"
import script from "./Fees.vue?vue&type=script&lang=js&"
export * from "./Fees.vue?vue&type=script&lang=js&"
import style0 from "./Fees.vue?vue&type=style&index=0&id=1f87e3dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f87e3dc",
  null
  
)

export default component.exports